export default "__VITE_ASSET__BouAL2TP__"